export const INTEGRATION_DETAIL_TOOLTIP_TITLE = 'Click to copy';

export const QUALTRICS_DATA_CENTERS = [
  { name: 'Canadian Data Center', value: 'yul1' },
  { name: 'Washington, DC Area Data Center', value: 'iad1' },
  { name: 'San Jose, California Data Center', value: 'sjc1' },
  { name: 'European Union Data Center', value: 'fra1' },
  { name: 'London, United Kingdom Data Center', value: 'lhr1' },
  { name: 'Sydney, Australia Data Center', value: 'syd1' },
  { name: 'Singapore Data Center', value: 'sin1' },
  { name: 'Tokyo, Japan Data Center', value: 'hnd1' },
  { name: 'US Government Data Center', value: 'gov1' },
];

export const MAX_IMPORTANT_METADATA_COUNT = 2;

export const STAR_METADATA_VISIBILITY_OFF_MESSAGE =
  "This metadata can't be starred as the visibility has been toggled off.";

export const STAR_METADATA_MAX_LIMIT_MESSAGE = `You have already starred the maximum of ${MAX_IMPORTANT_METADATA_COUNT} fields for this source. Please deselect others to star this.`;
